// Platform endpoints: Tiny Legends' own Firebase project (identity only) and its own Worker
// (purchases, cloud saves, auth mail) on tinylegendsgame.com.
//
// The Firebase web config is public by design: it ships in every web build, and access is
// controlled by Firebase Auth and Firestore rules, not by hiding it.

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAQVQXm6ZJxPQpLRFwMI0GSy5oDQXAAL2o',
  authDomain: 'tiny-legends-8eabf.firebaseapp.com',
  projectId: 'tiny-legends-8eabf',
  storageBucket: 'tiny-legends-8eabf.firebasestorage.app',
  messagingSenderId: '1071150521090',
  appId: '1:1071150521090:web:ab830faf0beb4db779c01b',
};

/** Tiny Legends' Worker (orders, grants, cloud save, auth mail). Override with VITE_API_BASE. */
export const API_BASE: string = (import.meta.env.VITE_API_BASE as string | undefined) ?? 'https://api.tinylegendsgame.com';

/** Pending grants live under users/{uid}/<this> (named when accounts were shared with The Archer Rouge; kept). */
export const GRANTS_COLLECTION = 'tlPendingGrants';

/** Legal pages shown at the terms prompt. TODO: Tiny Legends' own pages (docs/BEFORE_RELEASE.md). */
export const LEGAL = {
  terms: 'https://archer-rouge.com/terms',
  privacy: 'https://archer-rouge.com/privacy',
};
